$(document).ready(function() {
   $('#top_filter_wrapter li.list-menu__item.facets__item label.facet-checkbox input').parents('li.list-menu__item.facets__item').removeClass('active_filter_tab');
 $('#top_filter_wrapter li.list-menu__item.facets__item label.facet-checkbox input[type="checkbox"]:checked').parents('li.list-menu__item.facets__item').addClass('active_filter_tab');
  $(document).on('click','#top_filter_wrapter .list-menu__item.facets__item',function(){
    $(this).addClass('active_filter_tab');
    })
$(document).on('click','.grid-view-icon',function(e) {
            sessionStorage.setItem('collection-view', 'grid')
            $('.list-view-icon').removeClass('active')
            $('.grid-view-icon').addClass('active')
           document.getElementById('product-grid').classList.remove('collection-list');
          })
          $(document).on('click','.list-view-icon',function(e) {
            sessionStorage.setItem('collection-view', 'list')
            $('.grid-view-icon').removeClass('active')
            $('.list-view-icon').addClass('active')
             document.getElementById('product-grid').classList.add('collection-list');
           
     })
 if (sessionStorage.getItem('collection-view') === 'list'){
          document.getElementById('product-grid').classList.add('collection-list')
          $('.grid-view-icon').removeClass('active')
          $('.list-view-icon').addClass('active')
        }
  $(document).on('change','.range-slider .min_value_range,.range-slider .max_value_range',function(e){
    e.preventDefault();
   $('.field__input[name="filter.v.price.gte"]').val($('.min_value_range').val());
   $('.field__input[name="filter.v.price.lte"]').val($('.max_value_range').val());
   
})
});